var _ellipse, _circle, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConvocationBlobBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1438,
    height: 340,
    viewBox: "0 0 1438 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 873.369,
    cy: 177.183,
    rx: 76.8318,
    ry: 76.8319,
    fill: "#24C1A8",
    fillOpacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 600.5,
    cy: 262.5,
    r: 77.5,
    fill: "#24C1A8",
    fillOpacity: 0.1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 230.493,
    cy: 114.464,
    rx: 79.9678,
    ry: 79.9679,
    fill: "#24C1A8",
    fillOpacity: 0.1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 406.105,
    cy: 192.863,
    rx: 61.1518,
    ry: 61.1519,
    fill: "#24C1A8",
    fillOpacity: 0.1
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1196.38,
    cy: 70.5601,
    rx: 61.1518,
    ry: 61.1519,
    fill: "#24C1A8",
    fillOpacity: 0.1
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.0852,
    cy: 28.0852,
    rx: 28.0852,
    ry: 28.0852,
    transform: "matrix(0.780285 0.625423 -0.625423 0.780286 35.1309 178.752)",
    fill: "#24C1A8",
    fillOpacity: 0.1
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.0852,
    cy: 28.0852,
    rx: 28.0852,
    ry: 28.0852,
    transform: "matrix(0.780285 0.625423 -0.625423 0.780286 1057.46 116.031)",
    fill: "#24C1A8",
    fillOpacity: 0.1
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.4857,
    cy: 20.4857,
    rx: 20.4857,
    ry: 20.4857,
    transform: "matrix(0.780285 0.625423 -0.625423 0.780286 508.625 123)",
    fill: "#24C1A8",
    fillOpacity: 0.1
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.0852,
    cy: 28.0852,
    rx: 28.0852,
    ry: 28.0852,
    transform: "matrix(0.780285 0.625423 -0.625423 0.780286 1333.43 0)",
    fill: "#24C1A8",
    fillOpacity: 0.1
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.4766,
    cy: 12.4766,
    rx: 12.4766,
    ry: 12.4766,
    transform: "matrix(0.780285 0.625423 -0.625423 0.780286 94.002 159.936)",
    fill: "#24C1A8",
    fillOpacity: 0.1
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.4766,
    cy: 12.4766,
    rx: 12.4766,
    ry: 12.4766,
    transform: "matrix(0.780285 0.625423 -0.625423 0.780286 749.422 163.072)",
    fill: "#24C1A8",
    fillOpacity: 0.1
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.4766,
    cy: 12.4766,
    rx: 12.4766,
    ry: 12.4766,
    transform: "matrix(0.780285 0.625423 -0.625423 0.780286 994.029 222.656)",
    fill: "#24C1A8",
    fillOpacity: 0.1
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.4766,
    cy: 12.4766,
    rx: 12.4766,
    ry: 12.4766,
    transform: "matrix(0.780285 0.625423 -0.625423 0.780286 1420.53 84.6719)",
    fill: "#24C1A8",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvocationBlobBack);
export default __webpack_public_path__ + "static/media/convocation_blob_back.219431d40f36be3854019bea88cc0007.svg";
export { ForwardRef as ReactComponent };